exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(undefined);
// imports


// module
exports.push([module.id, ".lc_react-select-container{margin-top:10px}.lc_react-select-container #react-select-2-input{height:27px;margin-bottom:0px}.lc_react-select-container .lc_react-select__value-container{max-width:800px;overflow:hidden;text-overflow:ellipsis}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader!./node_modules/sass-loader/dist/cjs.js!./src/components/UI/TaggedInputText/taggedInputText.scss
// module id = 793
// module chunks = 5